export class ECBannerAd {
  constructor(form) {
    if (form) {
      this.list = form;
    } else {
      this.clear();
    }
  }

  clear() {
    this.list = [
      {
        ecBannerAdItem: {
          imageUrl: "",
          linkUrl: "",
          name: "首页和积分兑换列表",
          title: "",
        },
        key: "home_page_and_points_redemption_list",
        segment: "ec_banner_advertisement",
      },
      {
        ecBannerAdItem: {
          imageUrl: "",
          linkUrl: "",
          name: "LET'S 3主页",
          title: "",
        },
        key: "lets_3_home_page",
        segment: "ec_banner_advertisement",
      },
      {
        ecBannerAdItem: {
          imageUrl: "",
          linkUrl: "",
          name: "UAUR 主页",
          title: "",
        },
        key: "uaur_home_page",
        segment: "ec_banner_advertisement",
      },
      {
        ecBannerAdItem: {
          imageUrl: "",
          linkUrl: "",
          name: "活动详情页面",
          title: "",
        },
        key: "activity_details_page",
        segment: "ec_banner_advertisement",
      },
      {
        ecBannerAdItem: {
          imageUrl: "",
          linkUrl: "",
          name: "课程详情页面",
          title: "",
        },
        key: "course_details_page",
        segment: "ec_banner_advertisement",
      },
    ];
  }
}
